import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/LegalPage";
import { SITE_URL } from "@/lib/seo";
import { BRAND } from "@/lib/geo-config";

export const Route = createFileRoute("/datenschutz")({
  head: () => ({
    meta: [
      { title: "Datenschutz | Immobilienwert Online Zürich" },
      { name: "description", content: "Datenschutzerklärung der PartNET AG für Immobilienwert Online Zürich und die kostenlose Immobilienbewertung." },
      { property: "og:title", content: "Datenschutz | Immobilienwert Online Zürich" },
      { property: "og:description", content: "Informationen zur Bearbeitung und zum Schutz Ihrer Personendaten." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/datenschutz` },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/datenschutz` }],
  }),
  component: DatenschutzPage,
});

function DatenschutzPage() {
  return (
    <LegalPage eyebrow="Schutz Ihrer Daten" title="Datenschutzerklärung" intro="Hier erfahren Sie, welche Personendaten wir bearbeiten, weshalb wir dies tun und welche Rechte Sie haben.">
      <section>
        <h2>Verantwortliche Stelle</h2>
        <address className="mt-4 not-italic">
          {BRAND.company}<br />
          {BRAND.street}<br />
          {BRAND.postalCode} {BRAND.city}<br />
          Schweiz
        </address>
        <p>Telefon: <a href="tel:+41445128512">+41 44 512 85 12</a><br />E-Mail: <a href="mailto:info@partnet.ch">info@partnet.ch</a></p>
      </section>

      <section>
        <h2>Allgemeine Hinweise</h2>
        <p>Wir bearbeiten Personendaten im Einklang mit dem schweizerischen Datenschutzrecht, insbesondere dem Datenschutzgesetz (DSG), und – soweit anwendbar – der EU-Datenschutzgrundverordnung (DSGVO). Personendaten sind Angaben, die sich auf eine bestimmte oder bestimmbare Person beziehen.</p>
        <p>Wir treffen angemessene technische und organisatorische Massnahmen, um Personendaten vor unberechtigtem Zugriff, Verlust, Missbrauch oder Veränderung zu schützen. Eine Datenübertragung im Internet kann dennoch Sicherheitslücken aufweisen.</p>
      </section>

      <section>
        <h2>Besuch dieser Website</h2>
        <p>Beim Aufruf der Website können technisch erforderliche Angaben wie IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, übertragene Datenmenge, Browser und Betriebssystem in Server-Protokollen verarbeitet werden. Dies dient dem sicheren und zuverlässigen Betrieb, der Fehleranalyse und dem Schutz vor Missbrauch.</p>
        <p>Solche Angaben werden nur so lange aufbewahrt, wie dies für den jeweiligen Zweck oder aufgrund gesetzlicher Pflichten erforderlich ist.</p>
      </section>

      <section>
        <h2>Immobilienbewertung und Kontaktaufnahme</h2>
        <p>Wenn Sie das Formular zur Immobilienbewertung nutzen oder uns kontaktieren, bearbeiten wir die von Ihnen übermittelten Angaben zur Beantwortung Ihrer Anfrage, zur Vorbereitung einer Bewertung und für mögliche Anschlussfragen. Dazu können insbesondere Name, Kontaktangaben, Objektadresse und Angaben zur Immobilie gehören.</p>
        <p>Das Bewertungsformular wird über verkauf.partnet.ch eingebunden. Beim Laden und Absenden des Formulars können technisch erforderliche Verbindungsdaten und Ihre Formulareingaben an diesen von PartNET betriebenen Dienst übermittelt werden.</p>
      </section>

      <section>
        <h2>Eingebettete Inhalte</h2>
        <p>Auf der Website kann ein Video über die datenschutzfreundliche YouTube-Domain youtube-nocookie.com eingebettet sein. Erst wenn Sie das Video mit einem Klick starten, stellt Ihr Browser eine Verbindung zu Google beziehungsweise YouTube her. Dabei können Verbindungs- und Nutzungsdaten bearbeitet werden.</p>
        <p>Regionale Seiten zeigen eine lokal erzeugte Übersichtskarte. Ein weiterführender Kartenlink führt zu OpenStreetMap; erst beim Öffnen dieses Links gelten die Datenschutzbestimmungen des externen Anbieters.</p>
      </section>

      <section>
        <h2>Cookies und lokale Speicherung</h2>
        <p>Die Website kann technisch notwendige Cookies oder lokale Speicherfunktionen einsetzen, beispielsweise für die Anmeldung im nicht öffentlichen Verwaltungsbereich. Solche Funktionen dienen dem sicheren Betrieb. Marketing-Cookies werden nur eingesetzt, wenn dies auf der Website entsprechend ausgewiesen wird und die nötige Einwilligung vorliegt.</p>
      </section>

      <section>
        <h2>Weitergabe und Auftragsbearbeitung</h2>
        <p>Personendaten werden nur weitergegeben, wenn dies zur Erbringung unserer Leistungen erforderlich ist, eine gesetzliche Verpflichtung besteht oder Sie eingewilligt haben. Beauftragte Dienstleister dürfen Daten ausschliesslich nach unseren Weisungen und für den vereinbarten Zweck bearbeiten.</p>
      </section>

      <section>
        <h2>Ihre Rechte</h2>
        <p>Im Rahmen des anwendbaren Rechts können Sie Auskunft, Berichtigung, Löschung, Einschränkung der Bearbeitung, Datenherausgabe oder Widerspruch verlangen. Eine erteilte Einwilligung können Sie mit Wirkung für die Zukunft widerrufen. Zur Ausübung Ihrer Rechte kontaktieren Sie uns unter <a href="mailto:info@partnet.ch">info@partnet.ch</a>.</p>
      </section>

      <section>
        <h2>Änderungen</h2>
        <p>Wir können diese Datenschutzerklärung anpassen, wenn sich unsere Datenbearbeitung oder die Rechtslage ändert. Es gilt die jeweils auf dieser Website veröffentlichte Fassung.</p>
        <p>Stand: September 2026</p>
      </section>
    </LegalPage>
  );
}